import { ProfileForThisEvent } from './profileForThisEvent';
import { NewPageList } from "./new-page-list";

export class Speaker {
    $key: string;
    
    profile = new ProfileForThisEvent();
    
    prefix: string = null;
    name: string = null;
    email: string = null;
    type: string = null;
    position: number = 0;

    fileCMId: string = null;
    profileImageUri: string = null;
    
    isEmailVisible: boolean = false;
    isPhoneNumberVisible: boolean = false;
    isProfileImageVisible: boolean = true;
    
    // fileName: string;
    phoneNo: string;
    organization: string;
    designation: string;
    
    updatedAt: number;
    updatedAtImage: number;
    
    aboutList = new Array<NewPageList>();

    linkedIn: string = null;
    twitter: string = null;
    facebook: string = null;
    instagram: string = null;

}


// WEBPACK FOOTER //
// /app/src/app/core/models/speaker.ts